import { constants } from "redux/constants/redux-constants";

const initialState = {
  status: 'idle', // idle | creating_tutor | getting_signed_url | uploading | confirming_upload | processing | completed | error
  message: '',
  progress: 0,
  step: 0,
  totalSteps: 5,
  result: null,
  error: null,
  progress_percent: 0,
  stages: [],
};

const PIATutorBasedReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.PIA_TUTORBASED.STATUS_UPDATE:
      return {
        ...state,
        status: action.payload.status,
        message: action.payload.message,
        step: action.payload.step || state.step,
        totalSteps: action.payload.totalSteps || state.totalSteps,
        progress_percent: action.payload.progress_percent || state.progress_percent,
        stages: action.payload.stages || state.stages,
      };

    case constants.PIA_TUTORBASED.SUCCESS:
      return {
        ...state,
        status: 'completed',
        result: action.payload,
        message: action.payload?.message || 'Ingestion completed successfully!',
      };

    case constants.PIA_TUTORBASED.ERROR:
      return {
        ...state,
        status: 'error',
        error: action.payload,
      };

    case constants.PIA_TUTORBASED.RESET:
      return initialState;

    default:
      return state;
  }
};

export default PIATutorBasedReducer;
